import { render, staticRenderFns } from "./volumeTemplates.vue?vue&type=template&id=058ce49c&scoped=true"
import script from "./volumeTemplates.vue?vue&type=script&lang=js"
export * from "./volumeTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ce49c",
  null
  
)

export default component.exports